import './index.css';

import { Box, Spinner } from '@tonic-one/react';
const CSpinner = () => {
  return (
    <Box className="spinner-overlay">
      <Spinner />
    </Box>
  );
};

export default CSpinner;
